const GridTitle = () => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 245.3 21.59"
    className="grid-svg grid-title"
  >
    <defs></defs>
    <g>
      <g>
        <path
          d="M10.56,5.96C9.91,4.73,8.6,3.67,7,3.67c-2.35,0-2.41,1.76-2.41,1.99c0,1.46,1.34,2.04,2.6,2.49L9.8,9.1
			c1.23,0.45,2.69,1.29,3.5,2.41c0.25,0.34,1.15,1.68,1.15,3.61c0,0.92,0,3.67-2.91,5.43c-1.2,0.73-2.91,1.04-3.95,1.04
			c-3.61,0-5.74-0.87-7.59-4.17l3.5-2.32c0.76,1.74,2.13,2.8,3.89,2.8c0.98,0,2.74-0.45,2.74-2.32c0-1.54-0.84-1.88-3.92-3.08
			c-3.11-1.2-5.8-2.58-5.8-6.64c0-3.39,2.46-5.82,6.69-5.82c3.02,0,5.15,1.23,6.83,3.7L10.56,5.96z"
        />
        <path d="M17.95,0.45h13.8V4.2h-9.32v4.37h6.41v3.75h-6.36v4.84h9.91V21H17.95V0.45z" />
        <path d="M36.01,0.45h4.59v16.72h9.04V21H36.01V0.45z" />
        <path d="M53.17,0.45h13.8V4.2h-9.32v4.37h6.41v3.75h-6.36v4.84h9.91V21H53.17V0.45z" />
        <path
          d="M71.43,7.36c0-4.7,2.52-7.36,7.31-7.36c1.23,0,3.08,0.25,4.51,1.37c1.85,1.46,2.07,3.98,2.13,5.63h-4.51
			c-0.03-1.01-0.08-3.25-2.32-3.25c-0.56,0-1.26,0.22-1.71,0.64c-0.73,0.67-0.76,1.68-0.76,2.24v7.81c0,1.12,0,3.28,2.49,3.28
			c1.85,0,2.41-1.51,2.41-3.72h4.54c-0.03,1.48-0.06,1.65-0.2,2.52c-0.17,0.81-0.45,2.3-2.16,3.67c-1.46,1.18-3.58,1.37-4.48,1.37
			c-2.38,0-4.03-0.56-5.32-1.82c-0.84-0.81-1.93-1.99-1.93-6.19V7.36z"
        />
        <path d="M103.6,0.45V4.2h-5.12V21h-4.7V4.2h-5.24V0.45H103.6z" />
        <path
          d="M122.64,0.45L128.57,21h-4.4l-1.04-4.09h-6.3L115.78,21h-4.4l5.8-20.55H122.64z M119.98,4.12h-0.11l-2.24,9.3h4.62
			L119.98,4.12z"
        />
        <path
          d="M131.71,0.45h4.31l5.29,9.6c0.22,0.42,0.5,0.98,0.7,1.4c0.08,0.17,0.36,0.92,0.45,1.06h0.14l-0.11-2.07
			c-0.08-1.4-0.08-1.57-0.08-2.35V0.45h4.14V21h-3.7l-5.46-9.97c-0.45-0.81-0.48-0.9-1.54-3.39h-0.14c0.03,0.59,0.14,3.19,0.14,3.72
			V21h-4.14V0.45z"
        />
        <path d="M157.13,21v-1.82h2.41V2.24h-2.41V0.45h9.38v1.79h-2.44v16.88h2.44V21H157.13z" />
        <path
          d="M169.73,0.45h6.05l2.44,8.57c0.25,0.92,0.36,1.23,0.59,2.16c0.11,0.42,0.53,2.21,0.62,2.58h0.14
			c0.31-1.71,0.62-3,1.12-4.82l2.41-8.48h6.08V21h-3.95V9.94c0-1.46,0.11-3.89,0.2-5.85h-0.11L181.05,21h-3.11l-4.37-16.91h-0.14
			c0.03,0.95,0.2,5.12,0.2,5.99V21h-3.89V0.45z"
        />
        <path
          d="M203.61,0.45L209.55,21h-4.4l-1.04-4.09h-6.3L196.75,21h-4.4l5.8-20.55H203.61z M200.95,4.12h-0.11l-2.24,9.3h4.62
			L200.95,4.12z"
        />
        <path
          d="M212.01,8.04c0-1.82,0-4.42,2.13-6.38c1.57-1.43,3.42-1.62,5.4-1.62c3.89,0,6.66,2.38,6.66,6.36h-4.48
			c-0.08-1.82-1.01-2.66-2.55-2.66c-2.35,0-2.52,2.02-2.52,3.22v6.47c0,2.69,0.5,4.34,2.72,4.34c2.35,0,2.35-1.93,2.35-2.69v-1.4
			h-2.41v-3.42h6.89v10.98h-2.02l-0.59-1.43h-0.2c-0.59,0.7-1.51,1.76-4.68,1.76c-2.07,0-3.98-0.59-5.32-2.27
			c-1.12-1.43-1.4-3.14-1.4-5.68V8.04z"
        />
        <path d="M230.86,0.45h13.8V4.2h-9.32v4.37h6.41v3.75h-6.36v4.84h9.91V21h-14.45V0.45z" />
      </g>
    </g>
  </svg>
);

export default GridTitle;
